import * as React from 'react'
import { dateOptions } from '../../../constants'
import { type IFilterMode, LimitedDateFilter } from '@user/components/Filters'

export function StartDateFilter(props: IFilterMode) {
  return (
    <LimitedDateFilter
      {...props}
      name="startDate"
      label="Start Date"
      options={dateOptions}
    />
  )
}
